'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface ResourceCardProps {
  title: string;
  description: string;
  category: string;
  downloadUrl: string;
  image: string;
  alt: string;
  fileType: string;
  fileSize: string;
  downloads: number;
  isNew?: boolean;
}

const ResourceCard = ({
  title,
  description,
  category,
  downloadUrl,
  image,
  alt,
  fileType,
  fileSize,
  downloads,
  isNew = false,
}: ResourceCardProps) => {
  const handleDownload = () => {
    // Mock download functionality
    console.log(`Downloading: ${title}`);
  };

  return (
    <div className="bg-card rounded-lg shadow-soft hover:shadow-elevated transition-all duration-base overflow-hidden group">
      <div className="relative h-48 overflow-hidden">
        <AppImage
          src={image}
          alt={alt}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-base"
        />
        {isNew && (
          <div className="absolute top-4 right-4 bg-brand-purple text-white px-3 py-1 rounded-full text-xs font-semibold">
            New
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
          <span className="inline-block bg-accent text-accent-foreground px-3 py-1 rounded-full text-xs font-semibold">
            {category}
          </span>
        </div>
      </div>

      <div className="p-6">
        <h3 className="text-xl font-headline font-bold text-text-primary mb-2 line-clamp-2">
          {title}
        </h3>
        <p className="text-text-secondary text-sm mb-4 line-clamp-3">{description}</p>

        <div className="flex items-center justify-between mb-4 text-xs text-text-secondary">
          <div className="flex items-center space-x-4">
            <span className="flex items-center space-x-1">
              <Icon name="DocumentTextIcon" size={16} variant="outline" />
              <span>{fileType}</span>
            </span>
            <span className="flex items-center space-x-1">
              <Icon name="ArrowDownTrayIcon" size={16} variant="outline" />
              <span>{downloads} downloads</span>
            </span>
          </div>
          <span>{fileSize}</span>
        </div>

        <button
          onClick={handleDownload}
          className="w-full flex items-center justify-center space-x-2 bg-primary text-primary-foreground py-3 rounded-lg hover:bg-opacity-90 transition-all duration-base font-semibold"
        >
          <Icon name="ArrowDownTrayIcon" size={20} variant="solid" />
          <span>Download {fileType}</span>
        </button>
      </div>
    </div>
  );
};

export default ResourceCard;